/* eslint-disable max-len */
import React, { PropTypes } from 'react';

import MultimidiaBrumadinho from './MultimidiaBrumadinho';
import MultimidiaMariana from './MultimidiaMariana';

export default class Multimidia extends React.Component { 

	render() {
		const project = this.props.project;
		if (project === "mariana") return (<MultimidiaMariana />);
		if (project === "brumadinho") return (<MultimidiaBrumadinho />);
	}
}

Multimidia.propTypes = {
	project: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Multimidia/Multimidia.js